import React, { useMemo } from 'react'
import { PackType } from '../../types/pack'
import { DetailsTemplate } from '../../layouts'
import { PackDetails, H2, AddPublishScheduleArea } from '../../components'
import { checkIfSomeEditionIsDeleted } from '../../services/pack'

export interface IPackDetailsTab {
  pack: PackType
}

export const PackDetailsTab = ({ pack }: IPackDetailsTab) => {
  const someEditionIsDeleted = useMemo(
    () => checkIfSomeEditionIsDeleted(pack.editions),
    [pack.editions]
  )
  const noPublishLocations =
    !pack.editions ||
    !pack.editions.some(({ publishing }) =>
      publishing.locations.some(({ publish }) => publish)
    )
  return (
    <DetailsTemplate
      aside={
        <>
          <H2 mb={4}>Metadata</H2>
          <PackDetails pack={pack} />
        </>
      }
      contentProps={{ id: 'pack-details-tab-main' }}
      asideProps={{ id: 'pack-details-tab-aside' }}
    >
      {!pack.isLoading && (
        <AddPublishScheduleArea
          disableAddPublishSchedule={noPublishLocations || someEditionIsDeleted}
        />
      )}
    </DetailsTemplate>
  )
}
